import Link from "next/link"

import { storeSignupEmail } from "../utils/signupEmailHandoff"

export function CreateAccountLink({
  href,
  email,
}: {
  href: string
  email: string
}) {
  return (
    <Link
      href={href}
      onClick={(event) => {
        const opensNewTab =
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
        storeSignupEmail(href, opensNewTab ? "" : email)
      }}
      onAuxClick={(event) => {
        if (event.button === 1) {
          storeSignupEmail(href, "")
        }
      }}
      className="underline hover:text-coval-text"
    >
      Create an account
    </Link>
  )
}
